<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
        <Breadcrumb-item>学生量统计列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="50" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col :span="6" >
            <Form-item label="时间：">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期" value-format="yyyy-MM-dd" v-model="queryParam.statisticalDate" style="width: 100%;"/>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学导：">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyConsultantId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                    @click="exportData">导出
            </Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/dataCenter/studentDailyList"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>

<script>
    export default {
      components: {

      },
      name: 'studentDailyList',
      data () {
        return {
          exportLoading: false,
          searchLoading: false,
          reload: 0,
          queryParam: {
            statisticalDate: null,
            studyConsultantId: null
          },
          title: [
            {
              title: '级别',
              align: 'center',
              // width: 170,
              key: 'levelName',
            },
            {
              title: '总学生量',
              // width: 120,
              align: 'center',
              key: 'studentTotalCountSum'
            },
            {
              title: '总在读学生',
              // width: 150,
              align: 'center',
              key: 'studentInCountSum'
            },
            {
              title: '总停课学生数',
              // width: 150,
              align: 'center',
              key: 'studentClosedCountSum'
            },
            {
              title: '本月退费学生数',
              // width: 120,
              align: 'center',
              key: 'studentRefundMonthCountSum'
            },
            {
              title: '本月完结学生数',
              // width: 120,
              align: 'center',
              key: 'studentEndMonthCountSum'
            },
            {
              title: '本月新生',
              // width: 120,
              align: 'center',
              key: 'studentNewMonthCountSum'
            }
          ]
        }
      },
      mounted: function () {
        this.init()
      },
      created: function () {
        this.init()
      },
      methods: {
        init () {

        },
        exportData () {
          this.exportLoading = true
          this.$http.get('/dataCenter/studentDaily/exportExcel', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
            if (response.data) {
              let blob = new Blob([response.data], {type: 'text/csv'})
              let link = document.createElement('a')
              link.target = '_blank'
              link.href = window.URL.createObjectURL(blob)
              link.download = '学生数量统计.csv'
              link.click()
              this.exportLoading = false
            } else {
              this.$Message.error(response.msg)
            }
          }).catch((e) => {
            this.exportLoading = false
          })
        },
        search () {
          this.reload = new Date().getTime()
        },
        onLoading (loading) {
          this.searchLoading = loading
        }
      }
    }
</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// StudentDailyList.vue?440c2eb4